import Swiper from 'swiper/dist/js/swiper.min';


export default function () {
     new Swiper('#headerslider', {
        effect: 'fade',
        loop: true,
        autoplay: {
            delay: 5000
        },
        speed: 1000
    });

    new Swiper('.testslider', {
        effect: 'fade',
        loop: true,
        navigation: {
            nextEl: '.swiper-next',
            prevEl: '.swiper-prev'
        },
        autoplay: {
            delay: 5000
        },
        speed: 1000
    });


    new Swiper('#logoslider', {
        slidesPerView: 'auto',
        spaceBetween: 60,
        autoplay: {
            delay: 2500,
            disableOnInteraction: false
        },
        loop: true,
        freeMode: true
    });
 }
